export const FEEDBACK_TOPICS = [
  {
    value: 'IMPROVE',
    label: 'Improve our product',
  },
  {
    value: 'COMPLIMENT',
    label: 'Give us a compliment',
  },
];
